import { Component, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LeoBox } from "../../ui-helper"
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { TicketCreationDTO } from "../../services/webservice"
import * as model from "../../models";
import { ShoppingCartActions } from "./shopping-cart.actions";
import * as ui from "../../models/ui";
import { ShoppingCartEventListComponent } from "./shopping-cart-event-list/shopping-cart-event-list.component";
@Component({
	selector: 'shopping-cart',
	templateUrl: "./shopping-cart.html",
	styles: [require("./shopping-cart.scss")]
})
export class ShoppingCart {
	@Input() editable: boolean;

	protected displayShoppingCart$;
	protected orderComment;
	protected invalidComment = false;
	private shoppingCart: model.ShoppingCart
	@ViewChild(ShoppingCartEventListComponent)
	private shoppingCartEventListComponent: ShoppingCartEventListComponent

	constructor(
		protected store: Store<AppState>,
		private shoppingCartActions: ShoppingCartActions,
		private router: Router
	) { }

	ngOnInit() {
		this.displayShoppingCart$ = this.store.select("shoppingCart", "displayShoppingCart")
		this.store.select("shoppingCart", "shoppingCart").subscribe(shoppingCart => {
			this.shoppingCart = shoppingCart
		})
		this.store.select("shoppingCart", "orderComment").subscribe(orderComment => {
			this.orderComment = orderComment
		})
	}

	updateShoppingCart() {
		this.shoppingCartEventListComponent.displayEventsWithTicketControls.forEach(displayEventWithTicketControls => {
			let bulkTicketCreationDTOs: TicketCreationDTO[] = []
			let visualBulkTicketCreationDTOs: TicketCreationDTO[] = []
			let ticketItemUuidsToBeDeleted: string[] = []

			displayEventWithTicketControls.displayTicketsWithControls.forEach(displayTicketWithControl => {
				if (displayTicketWithControl.control.value > displayTicketWithControl.displayTicket.numberOfSeats) {
					let numberOfTicketsToAdd: number = displayTicketWithControl.control.value - displayTicketWithControl.displayTicket.numberOfSeats
						const ticketCreationDTO: TicketCreationDTO  = {
							priceLevelUUID: displayTicketWithControl.displayTicket.priceLevelUuid,
							ticketQuotaUUID: displayTicketWithControl.displayTicket.ticketQuotaUuid,
							numberOfTickets: numberOfTicketsToAdd
						}
						if (displayTicketWithControl.displayTicket.isVisualBulkTicket) {
							ticketCreationDTO.seatIdentifier = displayTicketWithControl.displayTicket.seatIdentifier
							visualBulkTicketCreationDTOs.push(ticketCreationDTO)
						}
						if (!displayTicketWithControl.displayTicket.isVisualBulkTicket && !displayTicketWithControl.displayTicket.isVisualTicket) {
							bulkTicketCreationDTOs.push(ticketCreationDTO)
						}
				} else if (displayTicketWithControl.control.value < displayTicketWithControl.displayTicket.numberOfSeats) {
					let numberOfTicketsToRemove: number = displayTicketWithControl.displayTicket.numberOfSeats - displayTicketWithControl.control.value
					for (let i = 0; i < numberOfTicketsToRemove; i++) {
						ticketItemUuidsToBeDeleted.push(displayTicketWithControl.displayTicket.ticketItemUuids[i])
					}
				}
			})

			if (bulkTicketCreationDTOs.length > 0) {
				this.store.dispatch(this.shoppingCartActions.addTickets(this.shoppingCart._links.tickets.href, bulkTicketCreationDTOs))
			}
			if (visualBulkTicketCreationDTOs.length > 0) {
				this.store.dispatch(this.shoppingCartActions.addVisualBulkTickets(this.shoppingCart._links.visualBulkTickets.href, visualBulkTicketCreationDTOs))
			}
			if (ticketItemUuidsToBeDeleted.length > 0) {
				this.store.dispatch(this.shoppingCartActions.removeTickets(this.shoppingCart._links.tickets.href, ticketItemUuidsToBeDeleted))
			}
		})
	}

	updateOrderComment(value) {
		if (!value.match(/^[\s\u0020-\u007E\u00A0-\u00FF€]{0,2000}$/)) {
			this.invalidComment = true;
			return;
		}
		this.invalidComment = false;
		this.store.dispatch(this.shoppingCartActions.updateOrderComment(value));
	}

	deleteShoppingCart() {
		this.store.dispatch(this.shoppingCartActions.deleteShoppingCart(this.shoppingCart._links.self.href))
	}
	detachShoppingcart() {
		this.router.navigate(['/shoppingCarts', 'detach']);
	}

	processRemoveTickets(ticketItemUuidsToBeRemoved: string[]) {
		this.store.dispatch(this.shoppingCartActions.removeTickets(this.shoppingCart._links.tickets.href, ticketItemUuidsToBeRemoved))
	}

	routeCheckout() {
		this.router.navigate(['/checkout'])
	}
}

export interface EventIdWithTicketGroups {
	eventUuid: string
	ticketGroupsWithControl: TicketGroupWithControl[]
}

export interface TicketGroupWithControl {
	ticketGroup: model.ShoppingCartTicketGroup
	control: FormControl
}



// WEBPACK FOOTER //
// ./src/app/components/shopping-cart/shopping-cart.component.ts